<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-12 d-flex align-items-center">
    <ol class="breadcrumb flex-grow-1 mb-0">
      <li class="breadcrumb-item">
        <a>Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>Support</a>
      </li>
      <li class="breadcrumb-item active">
        Ticket Search
      </li>
    </ol>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row mt-2">
    <div class="col-lg-12">
      <div class="card mb-3">
        <div class="card-body">
          <div class="row g-2 align-items-end">
            <div class="col-xl-4 col-lg-6">
              <label class="form-label small">Search</label>
              <div class="input-group input-group-sm">
                <input type="text" class="form-control" placeholder="Search by title, description or notes"
                  [(ngModel)]="searchText" (keyup.enter)="doSearch(true)">
                <button class="btn btn-outline-default" type="button" (click)="doSearch(true)" [disabled]="loading">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>

            <div class="col-xl-2 col-lg-3 col-md-4">
              <label class="form-label small">Status</label>
              <select class="form-select form-select-sm" [(ngModel)]="statusFilterId" (ngModelChange)="doSearch(true)">
                <option [ngValue]="null">All</option>
                <option *ngFor="let status of statusTypes" [ngValue]="status.id">{{status.status}}</option>
              </select>
            </div>

            <div class="col-xl-2 col-lg-3 col-md-4" *ngIf="azureAuthService.isAdmin()">
              <label class="form-label small">Customer</label>
              <select class="form-select form-select-sm" [(ngModel)]="customerFilterId" (ngModelChange)="onCustomerFilterChanged()">
                <option [ngValue]="null">All</option>
                <option *ngFor="let c of allCustomers" [ngValue]="c.customerId">{{c.customerName}}</option>
              </select>
            </div>

            <div class="col-xl-2 col-lg-3 col-md-4">
              <label class="form-label small">Assigned User</label>
              <select class="form-select form-select-sm" [(ngModel)]="assignedToUserFilterId" (ngModelChange)="doSearch(true)">
                <option [ngValue]="null">All</option>
                <option *ngFor="let user of users" [ngValue]="user.userId">{{user.displayName}}</option>
              </select>
            </div>

            <div class="col-xl-2 col-lg-3 col-md-4">
              <label class="form-label small">Raised By</label>
              <select class="form-select form-select-sm" [(ngModel)]="raisedByUserFilterId" (ngModelChange)="doSearch(true)">
                <option [ngValue]="null">All</option>
                <option *ngFor="let user of users" [ngValue]="user.userId">{{user.displayName}}</option>
              </select>
            </div>

            <div class="col-xl-2 col-lg-3 col-md-4 d-flex gap-2">
              <button class="btn btn-sm btn-outline-default w-100" (click)="clearFilters()" [disabled]="loading">Clear</button>
            </div>
          </div>

          <div class="d-flex align-items-center mt-3 ticket-search-toolbar">
            <div class="small text-muted flex-grow-1">
              {{totalItems}} ticket(s) found
            </div>
            <pagination
              [totalItems]="totalItems"
              [(ngModel)]="page"
              [itemsPerPage]="pageSize"
              [maxSize]="maxPages"
              [boundaryLinks]="true"
              [rotate]="false"
              previousText="&lsaquo;"
              nextText="&rsaquo;"
              firstText="&laquo;"
              lastText="&raquo;"
              [disabled]="loading"
              (pageChanged)="pageChange($event)">
            </pagination>
            <div class="ticket-page-size d-flex align-items-center gap-2">
              <label class="small text-muted mb-0">Page Size</label>
              <select class="form-select form-select-sm" [(ngModel)]="pageSize" (ngModelChange)="setPageSize($event)" [disabled]="loading">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
              </select>
            </div>
          </div>

          <div class="table-responsive mt-2">
            <table class="table table-striped table-hover mb-0">
              <thead>
                <tr>
                  <th style="width: 90px;">#</th>
                  <th>Title</th>
                  <th style="width: 140px;">Status</th>
                  <th style="width: 120px;">Priority</th>
                  <th style="width: 180px;">Customer</th>
                  <th style="width: 180px;">Assigned To</th>
                  <th style="width: 180px;">Raised By</th>
                  <th style="width: 170px;">Created</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loading">
                  <td colspan="8" class="text-center py-4">Loading tickets...</td>
                </tr>
                <tr *ngIf="!loading && tickets.length === 0">
                  <td colspan="8" class="text-center py-4">No tickets found</td>
                </tr>
                <tr *ngFor="let ticket of tickets" class="ticket-result-row" (click)="openEditTicket(ticket)">
                  <td>#{{ticket.id}}</td>
                  <td>
                    <div class="fw-500">{{ticket.title}}</div>
                    <div class="text-muted small" *ngIf="ticket.description">{{ticket.description}}</div>
                  </td>
                  <td>{{ticket.status?.status}}</td>
                  <td>{{ticket.priority?.priority}}</td>
                  <td>{{ticket.customerName}}</td>
                  <td>{{ticket.assignedToUser || 'Unassigned'}}</td>
                  <td>{{ticket.raisedByUser}}</td>
                  <td>{{ticket.createdDate | relativeDate}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-support-ticket-editor-modal
  #ticketEditor
  [selectedTicket]="selectedTicket"
  [priorityTypes]="priorityTypes"
  [statusTypes]="statusTypes"
  [allCustomers]="allCustomers"
  [users]="users"
  [(noteText)]="newNote"
  (saveTicket)="updateTicket($event)"
  (addNoteRequested)="addNote()"
  (acknowledgeTicket)="acknowledgeTicket($event)"
  (acceptOwnershipTicket)="acceptOwnership($event)"
  (closeTicket)="closeTicket($event)"
  (customerSelectionChanged)="onSelectedTicketCustomerChange($event)">
</app-support-ticket-editor-modal>
